import React from 'react';
import clsx from 'clsx';
import ErrorIcon from '@material-ui/icons/Error';
import { Tabs as MuiTabs, Tab as MuiTab } from '@material-ui/core';
import { useStyles } from './style';
import { useWhyDidYouUpdate } from 'hooks';

interface Props {
  tabs: Array<{
    id: string;
    label: React.ReactNode;
    title?: string;
    warning?: boolean;
  }>;
  onSelect: (id: string) => void;
  activeTab: string;
  cls?: {
    ul?: string;
    tab?: string;
    tabRoot?: string;
  };
}

function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const Tabs: React.FC<Props> = ({ tabs, onSelect, activeTab, cls }) => {
  useWhyDidYouUpdate('Tabs', {
    tabs,
    onSelect,
    activeTab,
    cls,
  });
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    onSelect(newValue);
  };

  return (
    <MuiTabs
      value={activeTab}
      variant="scrollable"
      scrollButtons="auto"
      onChange={handleChange}
      classes={{
        root: clsx(classes.root, cls?.ul),
        scrollButtons: classes.scrollButtons,
        indicator: classes.indicator,
      }}
    >
      {tabs.map((tab, idx) => (
        <MuiTab
          {...a11yProps(idx)}
          key={tab.id}
          label={tab.label}
          value={tab.id}
          classes={{
            root: clsx(classes.tabRoot, cls?.tabRoot),
            wrapper: clsx(classes.tab, cls?.tab),
            labelIcon: classes.labelIcon,
            textColorInherit: classes.textColorInherit,
            selected: classes.selected,
          }}
          icon={tab.warning ? <ErrorIcon /> : undefined}
        />
      ))}
    </MuiTabs>
  );
};

export default React.memo(Tabs);
